<script lang="ts" setup>
import { getDeviceCode } from "@/modules/common";
import { useTimeoutFn } from "@vueuse/core";
import { ref, useAttrs } from "vue";
import { Popup } from "vant";
import Cookie from "@/modules/cookie";
import { AppDeviceCookieName } from "@/enums/device";
import { useGlobalUser } from "@/stores/globalUser";
import { useMate } from "@/stores/mate";
import { twMerge } from "tailwind-merge";

const props = withDefaults(
  defineProps<{
    align?: "start" | "center";
  }>(),
  {
    align: "center",
  }
);

const appVersion = import.meta.env.PACKAGE_VERSION;
const isMainDomain = window.location.hostname.includes("any-mate.com");
const deviceCode = getDeviceCode();
const user = useGlobalUser();
const mate = useMate();
const clickCount = ref(0);
const showDetail = ref(false);
const refreshingMates = ref(false);
const attrs = useAttrs();
const isCN = !!import.meta.env.VITE_IS_CN;

const { start, stop } = useTimeoutFn(() => {
  clickCount.value = 0;
}, 3000);

const year = new Date().getFullYear();

// 点击事件处理函数
const handleClick = () => {
  clickCount.value++;
  if (clickCount.value === 8) {
    triggerPopup();
    clickCount.value = 0; // 重置计数器
    stop(); // 停止计时器
  } else {
    start(); // 重置计时器
  }
};
const triggerPopup = async () => {
  showDetail.value = true;
  try {
    refreshingMates.value = true;
    await mate.refreshCurrentMate();
  } finally {
    refreshingMates.value = false;
  }
};
</script>
<template>
  <div
    :class="
      twMerge(
        `${
          align === 'center' ? 'items-center' : 'item-start'
        } flex flex-col py-4`,
        attrs.class
      )
    "
    @click="handleClick"
  >
    <div class="text-xs text-base-content/50">
      {{ $t("SidebarNavi.version") }}: v{{
        `${appVersion}-${isMainDomain ? "1" : "2"}${deviceCode}-1`
      }}
    </div>

    <div class="text-xs text-base-content/50">
      ©{{ year }} {{ isCN ? "饼次元" : "AnyMate in Canada" }}
    </div>
    <Popup
      v-if="showDetail"
      v-model:show="showDetail"
      :close-on-click-overlay="false"
      :zIndex="10001"
      class="py-4"
      closeable
      position="bottom"
      round
      teleport="body"
    >
      <van-cell-group inset title="User">
        <van-cell :value="user.country" title="Region" />
        <van-cell
          :value="Cookie.get(AppDeviceCookieName) ?? 'Web'"
          title="Distribution"
        />
      </van-cell-group>
      <van-cell-group inset title="Current Mate">
        <div v-if="refreshingMates" class="flex justify-center">
          <div class="loading"></div>
        </div>
        <template v-else>
          <van-cell
            :value="mate.currentMate?.is_safe"
            title="is_safe(isProtectedMate)"
          />
          <van-cell
            :value="mate.currentMate?.isNsfw"
            title="isN(Detected as N Mate)"
          />
        </template>
      </van-cell-group>
    </Popup>
  </div>
</template>
